import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useBlocker } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  DataGrid,
  GridColDef,
  GridEditInputCell,
  GridRenderEditCellParams,
  GridRowModel,
} from "@mui/x-data-grid";
import { jaJP } from "@mui/x-data-grid/locales";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { showSnackbar } from "../../features/snackbar/snackbarSlice";
import {
  fetchSystemSettingAsync,
  getSystemSettingState,
} from "../../features/systemSetting/systemSettingSlice";
import { LoadingButton } from "@mui/lab";
import axiosConfig from "../../axiosConfig";
import CircularProgress from "@mui/material/CircularProgress";
import { reset } from "../../features/customerInfo/customerInfoSlice";
import { clearAccount } from "../../features/accountInfo/accountInfoSlice";
import Cookies from "js-cookie";

const SystemSetting = () => {
  const dispatch = useAppDispatch();
  const systemSettingData = useAppSelector(getSystemSettingState);
  useEffect(() => {
    setDataDeliveryDate(systemSettingData.dataDeliveryDate);
    setMaxProcessingCapacity(systemSettingData.maxProcessingCapacity);
    setFailedEstimateDisplayDays(systemSettingData.failedEstimateDisplayDays);
    setFailedEstimateNotifyTiming(
      systemSettingData.failedEstimateNotifyTiming
    );
    setCommentNotifyFrequency(systemSettingData.commentNotifyFrequency);
    setCustomerApprovalEnabled(systemSettingData.customerApprovalEnabled);
  }, [systemSettingData]);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const columns: GridColDef[] = [
    {
      field: "deviation",
      headerName: "基準日からの日数",
      width: 330,
      headerAlign: "center",
      align: "center",
      editable: true,
      type: "number",
      renderEditCell: (params: GridRenderEditCellParams) => {
        return (
          <GridEditInputCell
            {...params}
            inputProps={{
              onKeyDown: (event: any) => {
                if (event.key === ".") {
                  event.preventDefault();
                }
              },
            }}
          />
        );
      },
    },
    {
      field: "priceRatio",
      headerName: "価格倍率",
      width: 330,
      type: "number",
      headerAlign: "center",
      align: "center",
      editable: true,
    },
    {
      field: "maxCapacity",
      headerName: "受入上限（全体）",
      width: 180,
      type: "number",
      headerAlign: "center",
      align: "center",
      editable: true,
    },
    {
      field: "maxCapacityPerCustomer",
      headerName: "顧客ごとの上限",
      width: 180,
      type: "number",
      headerAlign: "center",
      align: "center",
      editable: true,
    },
    {
      field: "actions",
      headerName: "削除",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleDeleteReferenceDelivery(params.row.id)}
          >
            <RemoveIcon />
          </Button>
        );
      },
    },
  ];
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [nextPath, setNextPath] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoadingData(true);
      await dispatch(fetchSystemSettingAsync());
      setLoadingData(false);
    };
    fetchData();
  }, []);

  // Start: Data for system setting
  const [dataDeliveryDate, setDataDeliveryDate] = useState(
    systemSettingData.dataDeliveryDate
  );
  const prevDataDeliveryDateIds = useMemo(() => {
    return systemSettingData.dataDeliveryDate.map((item) => item.id);
  }, [systemSettingData.dataDeliveryDate]);
  const [referenceDeliveryDays, setreferenceDeliveryDays] = useState(
    systemSettingData.referenceDeliveryDays
  );
  const [limitAIEstimate, setLimitAIEstimate] = useState(
    systemSettingData.limitAIEstimate
  );
  const [limitBackloggedTickets, setLimitBackloggedTickets] = useState(
    systemSettingData.limitBackloggedTickets
  );
  const [limitCapacityOverload, setLimitCapacityOverload] = useState(
    systemSettingData.limitCapacityOverload
  );
  const [limitCapacityNumber, setLimitCapacityNumber] = useState(
    systemSettingData.limitCapacityNumber
  );
  const [limitDeadlineDelivery, setLimitDeadlineDelivery] = useState(
    systemSettingData.limitDeadlineDelivery
  );
  const [workingTime, setWorkingTime] = useState(systemSettingData.workingTime);
  const [maxProcessingCapacity, setMaxProcessingCapacity] = useState(
    systemSettingData.maxProcessingCapacity
  );
  const [failedEstimateDisplayDays, setFailedEstimateDisplayDays] = useState(
    systemSettingData.failedEstimateDisplayDays
  );
  const [failedEstimateNotifyTiming, setFailedEstimateNotifyTiming] =
    useState(systemSettingData.failedEstimateNotifyTiming);
  const [commentNotifyFrequency, setCommentNotifyFrequency] = useState(
    systemSettingData.commentNotifyFrequency
  );
  const [customerApprovalEnabled, setCustomerApprovalEnabled] = useState(
    systemSettingData.customerApprovalEnabled
  );
  const [capacityInfo, setCapacityInfo] = useState<{
    current_processing_count: number;
    remaining_capacity: number;
  } | null>(null);

  useEffect(() => {
    const fetchCapacityInfo = async () => {
      try {
        const response = await axiosConfig({
          method: "get",
          url: "/capacity/status",
        });
        setCapacityInfo(response.data.body);
      } catch (error) {
        console.error("Error fetching capacity info:", error);
      }
    };
    fetchCapacityInfo();
  }, []);
  // End: Data for system setting

  // Start: Block navigate if user not save setting
  const hasUnsavedChanges = () => {
    return (
      JSON.stringify(systemSettingData.dataDeliveryDate) !==
        JSON.stringify(dataDeliveryDate) ||
      systemSettingData.referenceDeliveryDays !== referenceDeliveryDays ||
      systemSettingData.limitAIEstimate !== limitAIEstimate ||
      systemSettingData.limitBackloggedTickets !== limitBackloggedTickets ||
      systemSettingData.limitCapacityOverload !== limitCapacityOverload ||
      systemSettingData.limitCapacityNumber !== limitCapacityNumber ||
      systemSettingData.limitDeadlineDelivery !== limitDeadlineDelivery ||
      systemSettingData.maxProcessingCapacity !== maxProcessingCapacity ||
      systemSettingData.failedEstimateDisplayDays !==
        failedEstimateDisplayDays ||
      systemSettingData.failedEstimateNotifyTiming !==
        failedEstimateNotifyTiming ||
      systemSettingData.commentNotifyFrequency !== commentNotifyFrequency ||
      systemSettingData.customerApprovalEnabled !== customerApprovalEnabled ||
      JSON.stringify(systemSettingData.workingTime) !==
        JSON.stringify(workingTime)
    );
  };
  const isValid = useRef(false);
  const [open, setOpen] = useState(false);
  const blocker = useBlocker((tx) => {
    setNextPath(tx.nextLocation.pathname);
    if (hasUnsavedChanges()) {
      setOpen(true);
      return true;
    } else {
      return false;
    }
  });
  // End: Block navigate if user not save setting

  const handleAddReferenceDelivery = () => {
    setDataDeliveryDate((prev: any) => [
      ...prev,
      {
        id:
          dataDeliveryDate.length > 0
            ? dataDeliveryDate[dataDeliveryDate.length - 1].id + 1
            : 0,
        deviation: 0,
        priceRatio: 0,
        maxCapacity: 0,
        maxCapacityPerCustomer: 0,
        isDelete: false,
        actions: "",
      },
    ]);
  };
  const handleDeleteReferenceDelivery = (id: number) => {
    if (prevDataDeliveryDateIds.includes(id))
      setDataDeliveryDate((prev) => [
        ...prev.map((item) =>
          item.id === id ? { ...item, isDelete: true } : item
        ),
      ]);
    else
      setDataDeliveryDate((prev) => [...prev.filter((item) => item.id !== id)]);
  };
  const processRowUpdate = (newRow: GridRowModel) => {
    const deviationList = dataDeliveryDate
      .filter((item) => item.id !== newRow.id && !item.isDelete)
      .map((item) => item.deviation);
    newRow.priceRatio =
      Number(newRow.priceRatio) >= 0 ? Number(newRow.priceRatio) : 0;
    newRow.maxCapacity =
      Number(newRow.maxCapacity) >= 0 ? Number(newRow.maxCapacity) : 0;
    newRow.maxCapacityPerCustomer =
      Number(newRow.maxCapacityPerCustomer) >= 0 ? Number(newRow.maxCapacityPerCustomer) : 0;

    if (
      Number(referenceDeliveryDays + newRow.deviation) < 0 ||
      deviationList.includes(newRow.deviation)
    ) {
      newRow.deviation = 0;
      isValid.current = true;
      dispatch(
        showSnackbar({
          type: "error",
          message: "入力した情報は既存のデータと重複してはいけません。",
        })
      );
    }

    setDataDeliveryDate((prev: any) =>
      prev.map((item: any) => {
        if (item.id === newRow.id) {
          item = { ...newRow };
        }
        return item;
      })
    );

    return newRow;
  };
  const handleProcessRowUpdateError = useCallback((error: Error) => {
    console.log(error);
  }, []);
  const handleUpdateWorkingTime = (type: string, value: string) => {
    if (type === "end" && value <= workingTime.start) {
      dispatch(
        showSnackbar({
          type: "error",
          message: "終業時間は始業時間より前に設定できません。",
        })
      );
    } else
      setWorkingTime((prev) => ({
        ...prev,
        [type]: value,
      }));
  };

  // Start Validate form
  const validateReferenceDeliveryTable = () => {
    const deviationList = dataDeliveryDate
      .filter(
        (item) =>
          !item.isDelete
      )
      .map((item) => item.deviation);

    return (
      deviationList.some((value) => value + referenceDeliveryDays > 0) &&
      deviationList.filter(
        (value, index, self) => self.indexOf(value) === index
      ).length === deviationList.length
    );
  };
  const validateReferenceDay = () => {
    let isValid = true;
    dataDeliveryDate
      .filter((item) => !item.isDelete)
      .forEach((item) => {
        if (item.deviation + referenceDeliveryDays < 0) {
          isValid = false;
        }
      });
    if (!isValid) {
      dispatch(
        showSnackbar({
          type: "error",
          message: "納期の設定のデータを適切に修正してください。",
        })
      );
    }
    return isValid;
  };
  // End Validate form

  const handleSaveChange = async () => {
    setLoading(true);
    let isValid = true;

    if (dataDeliveryDate.some(value => value.deviation===undefined || value.deviation===null)) {
      dispatch(
        showSnackbar({
          type: "error",
          message: "「基準日からの日数」が必須フィールドとなります。",
        })
      );
      setLoading(false);
      return;
    }

    if (!validateReferenceDeliveryTable() || !validateReferenceDay()) {
      isValid = false;
      dispatch(
        showSnackbar({
          type: "error",
          message: "納期の設定のデータを適切に修正してください。",
        })
      );
    }
    if (workingTime.start > workingTime.end) {
      isValid = false;
      dispatch(
        showSnackbar({
          type: "error",
          message: "終業時間は始業時間より前に設定できません。",
        })
      );
    }
    if (isValid) {
      const filterDataDelivery = dataDeliveryDate
        .filter(
          (item) => !item.isDelete || prevDataDeliveryDateIds.includes(item.id)
        )
        .map((item) =>
          prevDataDeliveryDateIds.includes(item.id)
            ? {
                id: item.id,
                deviation: item.deviation,
                price_ratio: item.priceRatio,
                max_capacity: item.maxCapacity ?? 0,
                max_capacity_per_customer: item.maxCapacityPerCustomer ?? 0,
                is_delete: item.isDelete,
                description: "",
              }
            : {
                deviation: item.deviation,
                price_ratio: item.priceRatio,
                max_capacity: item.maxCapacity ?? 0,
                max_capacity_per_customer: item.maxCapacityPerCustomer ?? 0,
                is_delete: item.isDelete,
                description: "",
              }
        );
      await axiosConfig({
        method: "post",
        url: "/settings",
        data: {
          sub_capacity_ratio: limitCapacityOverload,
          sub_standard_capacity: limitCapacityNumber,
          sub_allocation_ratio: workingTime.timeAllocation,
          sub_deadline_ratio: limitDeadlineDelivery,
          working_start_time: workingTime.start,
          working_end_time: workingTime.end,
          reference_days_delivery: referenceDeliveryDays,
          ai_estimate_threshold: limitAIEstimate,
          unprocessed_ticket_hours: limitBackloggedTickets,
          max_processing_capacity: maxProcessingCapacity,
          failed_estimate_display_days: failedEstimateDisplayDays,
          failed_estimate_notify_timing: failedEstimateNotifyTiming,
          comment_notify_frequency: commentNotifyFrequency,
          customer_approval_enabled: customerApprovalEnabled,
          flex_settings_list: filterDataDelivery,
        },
      })
        .then(async () => {
          await dispatch(fetchSystemSettingAsync());
          dispatch(
            showSnackbar({
              type: "success",
              message: "変更が正常に更新されました。",
            })
          );
        })
        .catch((e) => {
          dispatch(
            showSnackbar({
              type: "error",
              message:
                "エラーが発生しました。システムの管理者にお問い合わせください。",
            })
          );
          setLoading(false);
        });
    }
    setLoading(false);
  };

  const handleCancelChange = () => {
    setDataDeliveryDate(systemSettingData.dataDeliveryDate);
    setreferenceDeliveryDays(systemSettingData.referenceDeliveryDays);
    setLimitAIEstimate(systemSettingData.limitAIEstimate);
    setLimitBackloggedTickets(systemSettingData.limitBackloggedTickets);
    setLimitCapacityOverload(systemSettingData.limitCapacityOverload);
    setLimitCapacityNumber(systemSettingData.limitCapacityNumber);
    setLimitDeadlineDelivery(systemSettingData.limitDeadlineDelivery);
    setMaxProcessingCapacity(systemSettingData.maxProcessingCapacity);
    setFailedEstimateDisplayDays(systemSettingData.failedEstimateDisplayDays);
    setFailedEstimateNotifyTiming(
      systemSettingData.failedEstimateNotifyTiming
    );
    setCommentNotifyFrequency(systemSettingData.commentNotifyFrequency);
    setCustomerApprovalEnabled(systemSettingData.customerApprovalEnabled);
    setWorkingTime(systemSettingData.workingTime);
  };

  return (
    <div className=" flex flex-col">
      <Header pageTitle="システム設定" disableLogout={hasUnsavedChanges()} />
      <Grid container sx={{ height: "90vh" }} className="pb-6">
        <Grid item xs={2} className="py-2 bg-gray-100 h-full">
          <List component="nav" sx={{ color: "#3E6EB4" }}>
            <ListItemButton
              selected={selectedIndex === 0}
              onClick={() => setSelectedIndex(0)}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#3E6EB4",
                  color: "#fff",
                },
              }}
            >
              <SettingsIcon className="mr-4" />
              <ListItemText primary="システム設定" />
            </ListItemButton>
          </List>
        </Grid>
        <Grid
          item
          xs={10}
          className="h-full pb-6 pt-6 px-6"
          sx={{ overflowX: "hidden", overflowY: "scroll" }}
        >
          {loadingData && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: 40,
              }}
            >
              <CircularProgress />
            </Box>
          )}
          {!loadingData && (
            <Fragment>
              {/* Reference Delivery */}
              <Card
                className="mx-auto"
                sx={{ border: 1, borderColor: "grey.300", width: 1200 }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="納期の設定"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Card
                    className="mx-auto"
                    sx={{ border: 1, borderColor: "grey.300", width: 1002 }}
                    variant="outlined"
                  >
                    <CardHeader
                      sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                      subheader="基準日の設定（自動見積の返却価格が設定される日）"
                    />
                    <CardContent sx={{ paddingY: "5px" }}>
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <p>本日から</p>
                        <TextField
                          value={referenceDeliveryDays}
                          type="number"
                          onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                            e.target.value = e.target.value.replace(".", "");
                          }}
                          onChange={(e) => {
                            if (Number(e.target.value) >= 0)
                              setreferenceDeliveryDays(Number(e.target.value));
                          }}
                          onBlur={() => validateReferenceDay()}
                          size="small"
                          sx={{ width: 80 }}
                        />
                        <p>営業日後</p>
                      </Stack>
                    </CardContent>
                  </Card>
                  <Box sx={{ marginX: "90px", marginY: "3vh" }}>
                    <DataGrid
                      localeText={
                        jaJP.components.MuiDataGrid.defaultProps.localeText
                      }
                      editMode="row"
                      rows={dataDeliveryDate.filter((item) => !item.isDelete)}
                      columns={columns}
                      disableColumnMenu
                      disableColumnSorting
                      disableRowSelectionOnClick
                      processRowUpdate={processRowUpdate}
                      onProcessRowUpdateError={handleProcessRowUpdateError}
                      hideFooter
                    />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleAddReferenceDelivery}
                    >
                      <AddIcon />
                    </Button>
                  </Box>
                  <p style={{ color: "#666", fontSize: "0.85rem", marginTop: "8px" }}>
                    ※ 受入上限（全体）・顧客ごとの上限は 0 に設定すると制限なし
                  </p>
                </CardContent>
              </Card>
              {/* Alert Error AI Estimate */}
              <Card
                className="mx-auto mt-6"
                sx={{ border: 1, borderColor: "grey.300", width: 1200 }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="見積もり異常"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <p>見積もり異常アラート枚数</p>
                    <TextField
                      value={limitAIEstimate}
                      type="number"
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (Number(e.target.value) >= 0)
                          setLimitAIEstimate(Number(e.target.value));
                      }}
                      size="small"
                      sx={{ width: 80 }}
                    />
                    <p>枚</p>
                  </Stack>
                </CardContent>
              </Card>
              {/* Alert Backlogged Tickets */}
              <Card
                className="mx-auto mt-6"
                sx={{ border: 1, borderColor: "grey.300", width: 1200 }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="未処理チケット"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <p>未処理チケットアラート待機時間</p>
                    <TextField
                      value={limitBackloggedTickets}
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (
                          Number(e.target.value) <= 24 &&
                          Number(e.target.value) >= 0
                        )
                          setLimitBackloggedTickets(Number(e.target.value));
                      }}
                      size="small"
                      type="number"
                      sx={{ width: 80 }}
                    />
                    <p>時間</p>
                  </Stack>
                </CardContent>
              </Card>
              {/* Alert Capacity Overload */}
              <Card
                className="mx-auto mt-6"
                sx={{ border: 1, borderColor: "grey.300", width: 1200 }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="キャパシティ超過アラート"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <p>キャパシティ超過アラート割合</p>
                    <TextField
                      value={limitCapacityOverload}
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (
                          Number(e.target.value) <= 100 &&
                          Number(e.target.value) >= 0
                        )
                          setLimitCapacityOverload(Number(e.target.value));
                      }}
                      size="small"
                      type="number"
                      sx={{ width: 80 }}
                    />
                    <p>%</p>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    className="mt-5"
                  >
                    <p>外注先標準1日処理可能枚数</p>
                    <TextField
                      value={limitCapacityNumber}
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (Number(e.target.value) >= 0)
                          setLimitCapacityNumber(Number(e.target.value));
                      }}
                      size="small"
                      type="number"
                      sx={{ width: 80 }}
                    />
                    <p>枚</p>
                  </Stack>
                </CardContent>
              </Card>
              {/* Alert Deadline Delivery */}
              <Card
                className="mx-auto mt-6"
                sx={{ border: 1, borderColor: "grey.300", width: 1200 }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="納期逸脱"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <p>納期逸脱アラート割合</p>
                    <TextField
                      value={limitDeadlineDelivery}
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (
                          Number(e.target.value) <= 100 &&
                          Number(e.target.value) >= 0
                        )
                          setLimitDeadlineDelivery(Number(e.target.value));
                      }}
                      type="number"
                      size="small"
                      sx={{ width: 80 }}
                    />
                    <p>%</p>
                  </Stack>
                </CardContent>
              </Card>
              {/* Setting subcontractor allocation ratio delivery time */}
              <Card
                className="mx-auto mt-6"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  width: 1200,
                }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="納品時間割付設定"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <p>外注先の納品割合</p>
                    <TextField
                      value={workingTime.timeAllocation}
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (
                          Number(e.target.value) <= 100 &&
                          Number(e.target.value) >= 0
                        )
                          setWorkingTime((prev) => ({
                            ...prev,
                            timeAllocation: Number(e.target.value),
                          }));
                      }}
                      size="small"
                      type="number"
                      sx={{ width: 80 }}
                    />
                    <p>%</p>
                  </Stack>
                </CardContent>
              </Card>
              {/* Setting employee working time */}
              <Card
                className="mx-auto mt-6"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  width: 1200,
                }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="自社の勤務時間"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    className="mt-5"
                  >
                    <p>自社の始業時間</p>
                    <input
                      type="time"
                      style={{
                        padding: 6,
                        border: "solid 1px #bdbdbd",
                        borderRadius: 4,
                      }}
                      value={workingTime.start}
                      onChange={(e) => {
                        handleUpdateWorkingTime("start", e.target.value);
                      }}
                    />
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    className="mt-5"
                  >
                    <p>自社の終業時間</p>
                    <input
                      type="time"
                      style={{
                        padding: 6,
                        border: "solid 1px #bdbdbd",
                        borderRadius: 4,
                      }}
                      value={workingTime.end}
                      onChange={(e) => {
                        handleUpdateWorkingTime("end", e.target.value);
                      }}
                    />
                  </Stack>
                </CardContent>
              </Card>
              {/* 同時処理上限 */}
              <Card
                className="mx-auto mt-6"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  width: 1200,
                }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="同時処理上限"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <p>同時処理上限枚数</p>
                    <TextField
                      value={maxProcessingCapacity}
                      type="number"
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (Number(e.target.value) >= 0)
                          setMaxProcessingCapacity(Number(e.target.value));
                      }}
                      size="small"
                      sx={{ width: 100 }}
                    />
                    <p>枚</p>
                  </Stack>
                  <p style={{ color: "#666", fontSize: "0.85rem", marginTop: "4px" }}>
                    ※ 0に設定すると制限なし
                  </p>
                  {capacityInfo && (
                    <Stack spacing={1} className="mt-3">
                      <p>
                        現在の処理中枚数: {capacityInfo.current_processing_count} 枚
                      </p>
                      {maxProcessingCapacity > 0 && (
                        <p>
                          残り受入可能枚数:{" "}
                          {Math.max(maxProcessingCapacity - capacityInfo.current_processing_count, 0)} 枚
                        </p>
                      )}
                    </Stack>
                  )}
                </CardContent>
              </Card>
              {/* 見積不可案件の表示期間 */}
              <Card
                className="mx-auto mt-6"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  width: 1200,
                }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="見積不可案件の表示期間"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <p>案件一覧に表示する期間</p>
                    <TextField
                      value={failedEstimateDisplayDays}
                      type="number"
                      onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
                        e.target.value = e.target.value.replace(/\./g, "");
                      }}
                      onChange={(e) => {
                        if (Number(e.target.value) >= 0)
                          setFailedEstimateDisplayDays(Number(e.target.value));
                      }}
                      size="small"
                      sx={{ width: 100 }}
                    />
                    <p>日</p>
                  </Stack>
                  <p style={{ color: "#666", fontSize: "0.85rem", marginTop: "4px" }}>
                    ※ 0に設定すると無期限で表示します
                  </p>
                </CardContent>
              </Card>
              {/* 見積不可図面の通知タイミング */}
              <Card
                className="mx-auto mt-6"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  width: 1200,
                }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="見積不可図面の通知タイミング"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <RadioGroup
                    value={failedEstimateNotifyTiming}
                    onChange={(e) =>
                      setFailedEstimateNotifyTiming(e.target.value)
                    }
                  >
                    <FormControlLabel
                      value="estimate"
                      control={<Radio />}
                      label="見積時に通知"
                    />
                    <FormControlLabel
                      value="order"
                      control={<Radio />}
                      label="発注時に通知"
                    />
                    <FormControlLabel
                      value="none"
                      control={<Radio />}
                      label="通知なし"
                    />
                  </RadioGroup>
                </CardContent>
              </Card>
              {/* コメント通知頻度 */}
              <Card
                className="mx-auto mt-6"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  width: 1200,
                }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="コメント通知頻度"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <RadioGroup
                    value={commentNotifyFrequency}
                    onChange={(e) =>
                      setCommentNotifyFrequency(e.target.value)
                    }
                  >
                    <FormControlLabel
                      value="immediate"
                      control={<Radio />}
                      label="即時（投稿のたび）"
                    />
                    <FormControlLabel
                      value="daily"
                      control={<Radio />}
                      label="1日1回サマリー"
                    />
                    <FormControlLabel
                      value="none"
                      control={<Radio />}
                      label="通知なし"
                    />
                  </RadioGroup>
                </CardContent>
              </Card>
              {/* 新規のお客様の承認機能（設計04） */}
              <Card
                className="mx-auto mt-6"
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  width: 1200,
                }}
              >
                <CardHeader
                  sx={{ bgcolor: "#F5F5F5", paddingY: "5px" }}
                  subheader="新規のお客様の承認機能"
                />
                <CardContent sx={{ padding: "20px" }}>
                  <RadioGroup
                    value={customerApprovalEnabled ? "on" : "off"}
                    onChange={(e) =>
                      setCustomerApprovalEnabled(e.target.value === "on")
                    }
                  >
                    <FormControlLabel
                      value="off"
                      control={<Radio />}
                      label="オフ（新規のお客様もすぐに発注できる）"
                    />
                    <FormControlLabel
                      value="on"
                      control={<Radio />}
                      label="オン（管理者が承認するまで発注できない）"
                    />
                  </RadioGroup>
                  <p className="mt-2 text-sm text-gray-600">
                    ※
                    オンにすると、新しく登録されたお客様は「承認待ち顧客」タブに表示され、
                    管理者が承認するまで発注確定ができなくなります。見積までは行えます。
                  </p>
                  <p className="text-sm text-gray-600">
                    ※ すでに登録済みのお客様は承認済みとして扱われ、影響はありません。
                  </p>
                </CardContent>
              </Card>
              <Stack
                direction="row"
                spacing={6}
                sx={{
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: 1200,
                  marginX: "auto",
                  marginY: 3,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleCancelChange}
                  sx={{ width: 120 }}
                >
                  キャンセル
                </Button>
                <LoadingButton
                  variant="contained"
                  loading={loading}
                  onClick={handleSaveChange}
                  sx={{ width: 120 }}
                >
                  保存
                </LoadingButton>
              </Stack>
            </Fragment>
          )}
        </Grid>
      </Grid>{" "}
      {/* Alert Popup If not saved */}
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            設定内容が保存されていません。よろしいいですか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>キャンセル</Button>
          {blocker.state === "blocked" && (
            <Button
              autoFocus
              onClick={() => {
                if (nextPath === "/login") {
                  dispatch(reset());
                  dispatch(clearAccount());
                  Cookies.remove("access_token");
                }
                blocker.proceed();
              }}
            >
              続行
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Box
        role="presentation"
        sx={{
          position: "fixed",
          bottom: 100,
          right: 40,
          display: "flex",
          flexDirection: "column",
        }}
      ></Box>
      <Footer />
    </div>
  );
};

export default SystemSetting;
